import MonthlyDailyStore from './MonthlyDailyStore';

export default MonthlyDailyStore;
